import { getState } from './App';

export const getUserFields = profile => {
  const state = getState();
  if (state) {
    const fields = state.App.userFields;
    return fields.map(uf => {
      const fieldValue = (profile && profile.fields) ?
        profile.fields.find(f => f.id === uf.id) : null;
      return {
        ...uf,
        value: fieldValue ? fieldValue.value : null,
      };
    });
  }

  return [];
};

export const getUserFieldByRole = (userFields, role) => (
  userFields.find(uf => (uf.role === role))
);
